<template>
  <v-card class="elevation-0" style="width:100%">
    <v-card-title style="word-break: break-word">
      {{ step.stepName }}
    </v-card-title>
    <v-card-text>
      <span style="word-break:keep-all" v-html="step.stepDescription"></span>
      <v-row no-gutters cols="12" v-if="!vehicleInfoIsEmpty" style="margin-top: 5px">
        <v-col>
          <span style="font-size:14px"><b>{{ vehicleInfo.plateNumber }}</b></span>
          <span style="font-size:14px"> {{ vehicleInfo.vehicleYear }}</span>
          <span style="font-size:14px"> {{ vehicleInfo.make }}</span>
          <span style="font-size:14px"> {{ vehicleInfo.model }}&nbsp;</span>
          <span style="font-size:14px" v-if="showUnitNumber"><b>Unit #</b>&nbsp;{{ vehicleInfo.unitNumber }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
  // WrsWizardStepHeader.vue

  export default {
    props: ['step', 'vehicleInfo'],
    computed: {
      vehicleInfoIsEmpty: function () {
        if (this.vehicleInfo == null) return true;
        return Object.keys(this.vehicleInfo).length === 0;
      },
      showUnitNumber: function () {
        if (this.vehicleInfoIsEmpty) return false;
        if (this.vehicleInfo.unitNumber == null) return false;
        if (this.vehicleInfo.unitNumber == "") return false;
        return true;
      }
    }
  }
</script>
